import { Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { CreateProduct } from '@thro-types/leihbar';

import { Field, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export const ContactEmailForm = () => {
  const { t } = useTranslation();
  const { values, setFieldValue, errors, touched } = useFormikContext<CreateProduct>();
  const mailDomains = ['th-rosenheim.de', 'stud.th-rosenheim.de'];
  const domainFromLender = values.lender?.email.split('@').pop() || '';

  if (import.meta.env.VITE_NODE_ENV !== 'production' || import.meta.env.VITE_IS_STAGING) {
    mailDomains.push('devUser.de');
  }

  const [preAtValue, setpreAtValue] = useState(values.lender?.email.split('@')[0] || '');
  const [domain, setDomain] = useState(
    mailDomains.includes(domainFromLender) ? domainFromLender : mailDomains[0]
  );

  const handlepreAtChange = event => {
    // Remove "@" character from the value
    const modifiedValue = event.target.value.replace(/@/g, '');
    setpreAtValue(modifiedValue);
  };

  const handleDomainChange = event => {
    setDomain(event.target.value);
  };

  useEffect(() => {
    setFieldValue('lender.email', `${preAtValue}@${domain}`);
  }, [domain, preAtValue, setFieldValue]);

  return (
    <Grid container>
      <Grid item xs={6} md={4}>
        <Field
          as={TextField}
          id="lender.email"
          name="lender.email"
          placeholder={t(translations.pages.leihbar.product.create.placeholder.enterEmail())}
          fullWidth
          size="small"
          onChange={handlepreAtChange}
          value={preAtValue}
          error={touched.lender?.email && Boolean(errors.lender?.email)}
          helperText={touched.lender?.email && errors.lender?.email}
        />
      </Grid>
      <Grid item xs={1} md={1} className="product-create__contact">
        <Typography>@</Typography>
      </Grid>
      <Grid item xs={5} md={4}>
        <Select fullWidth value={domain} onChange={handleDomainChange} size="small">
          {mailDomains.map(domain => (
            <MenuItem key={domain} value={domain}>
              {domain}
            </MenuItem>
          ))}
        </Select>
      </Grid>
    </Grid>
  );
};
